<div #chartdiv id="chartdiv" style="width: 100%; height: 500px; overflow: hidden;"></div>